var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from "lit";
import { customElement, property } from "lit/decorators.js";
let BasicSummary = class BasicSummary extends LitElement {
    constructor() {
        super(...arguments);
        this.open = false;
        this.variant = "primary";
        this.size = "medium";
        this.special = false;
    }
    onToggle(e) {
        this.open = e.currentTarget.open;
    }
    render() {
        const classes = [
            `variant-${this.variant}`,
            `size-${this.size}`,
            this.special ? "special" : ""
        ].join(" ");
        return html `
      <details
        class="${classes}"
        ?open=${this.open}
        @toggle=${this.onToggle}
      >
        <summary>
          <span class="summary-content">
            <span>${this.title}</span>
            ${this.description
            ? html `<span class="description">${this.description}</span>`
            : null}
          </span>
          <span class="arrow">▶</span>
        </summary>

        <slot></slot>
      </details>
    `;
    }
};
BasicSummary.styles = css `
    /* =========================
       Base
    ========================== */
    details {
      border-radius: 6px;
      background-color: #f9f9f9;
      border: 1px solid transparent;
    }

    summary {
      cursor: pointer;
      list-style: none;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      outline: none;
      font-weight: bold;
      transition: 
        border-color 0.3s,
        box-shadow 0.3s,
        background-color 0.3s;
    }

    summary::-webkit-details-marker {
      display: none;
    }

    .summary-content {
      display: flex;
      flex-direction: column;
      flex: 1;
    }

    .description {
      margin-top: 2px;
      font-size: 0.9em;
      font-weight: normal;
      color: #555;
    }

    .arrow {
      margin-left: 12px;
      margin-top: 2px;
      transition: transform 0.2s ease-in-out;
    }

    details[open] .arrow {
      transform: rotate(90deg);
    }

    /* =========================
       Variants (DETAILS)
    ========================== */
    details.variant-primary { border-color: #0078d4; }
    details.variant-secondary { border-color: #6c757d; }
    details.variant-success { border-color: #28a745; }
    details.variant-danger { border-color: #dc3545; }
    details.variant-warning { border-color: #ffc107; }

    /* =========================
       Sizes (DETAILS)
    ========================== */
    details.size-small summary {
      font-size: 12px;
      padding: 6px 10px;
    }

    details.size-medium summary {
      font-size: 14px;
      padding: 8px 12px;
    }

    details.size-large summary {
      font-size: 18px;
      padding: 12px 16px;
      line-height: 1.5;
    }

    /* =========================
       Special (DETAILS)
    ========================== */
    details.special.variant-primary {
      background-color: rgba(0, 120, 212, 0.1);
    }

    details.special.variant-secondary {
      background-color: rgba(108, 117, 125, 0.1);
    }

    details.special.variant-success {
      background-color: rgba(40, 167, 69, 0.1);
    }

    details.special.variant-danger {
      background-color: rgba(220, 53, 69, 0.1);
    }

    details.special.variant-warning {
      background-color: rgba(255, 193, 7, 0.1);
    }

    /* Content */
    ::slotted(*) {
      padding: 10px 12px;
    }
  `;
__decorate([
    property({ type: String })
], BasicSummary.prototype, "title", void 0);
__decorate([
    property({ type: String })
], BasicSummary.prototype, "description", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], BasicSummary.prototype, "open", void 0);
__decorate([
    property({ type: String })
], BasicSummary.prototype, "variant", void 0);
__decorate([
    property({ type: String })
], BasicSummary.prototype, "size", void 0);
__decorate([
    property({ type: Boolean })
], BasicSummary.prototype, "special", void 0);
BasicSummary = __decorate([
    customElement("basic-summary")
], BasicSummary);
export { BasicSummary };
//# sourceMappingURL=BasicSummary.js.map